// Auth context — Emergent Google OAuth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Send cookies with every request so session_token flows through.
axios.defaults.withCredentials = true;

const AuthContext = createContext({
    user: null,
    loading: true,
    login: () => {},
    logout: async () => {},
    refresh: async () => {},
});

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkMe = useCallback(async () => {
        try {
            const r = await axios.get(`${API}/auth/me`);
            setUser(r.data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    // Handle #session_id in URL first (from Emergent redirect), then /auth/me
    useEffect(() => {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (m) {
            const session_id = decodeURIComponent(m[1]);
            (async () => {
                try {
                    const r = await axios.post(`${API}/auth/session`, { session_id });
                    setUser(r.data);
                } catch (e) {
                    console.error("session exchange failed", e);
                } finally {
                    // strip the session_id fragment
                    const clean = hash.replace(/#?session_id=[^&]+&?/, "");
                    window.history.replaceState(null, "", window.location.pathname + (clean ? clean : ""));
                    setLoading(false);
                }
            })();
        } else {
            checkMe();
        }
    }, [checkMe]);

    const login = useCallback(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
        const redirectUrl = window.location.origin + window.location.pathname;
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }, []);

    const logout = useCallback(async () => {
        try {
            await axios.post(`${API}/auth/logout`);
        } catch {
            /* ignore */
        }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh: checkMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
